import { Field, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import Input from '@tmh-website/ui/Input';
import type { FormElementThemeColor } from '@tmh-website/ui/FormElements';
import RadioGroup from '@tmh-website/ui/RadioGroup';

import type { BusinessUnitSolutionsWeb2CaseFormValues } from '../BusinessUnitSolutionsWeb2CaseForm.schema';
import { useBusinessUnitSolutionsWeb2CaseForm } from '../BusinessUnitSolutionsWeb2CaseForm.hooks';

type ReplacementFieldsProps = {
  formElementThemeColor: FormElementThemeColor;
};

export const ReplacementFields = ({ formElementThemeColor }: ReplacementFieldsProps): JSX.Element | undefined => {
  const { t } = useTranslation();
  const { values } = useFormikContext<BusinessUnitSolutionsWeb2CaseFormValues>();
  const { fieldLabels } = useBusinessUnitSolutionsWeb2CaseForm();

  if (values.question !== 'Replacement') {
    return undefined;
  }

  return (
    <>
      <Field
        as={Input}
        themeColor={formElementThemeColor}
        label={fieldLabels.chargepilot_site}
        name='chargepilot_site'
        maxLength={500}
        required
      />
      <Field
        as={Input}
        themeColor={formElementThemeColor}
        label={fieldLabels.old_serial_number}
        name='old_serial_number'
        required
      />
      <Field
        as={Input}
        themeColor={formElementThemeColor}
        label={fieldLabels.new_serial_number}
        name='new_serial_number'
        required
      />
      <Field
        as={RadioGroup}
        themeColor={formElementThemeColor}
        options={t('blocks:staticForms.stationStatusOptions', { returnObjects: true })}
        label={fieldLabels.is_station_online}
        name='is_station_online'
        required
      />
      <Field as={Input} themeColor={formElementThemeColor} label={fieldLabels.message} name='message' />
    </>
  );
};
